export default __webpack_public_path__ + "static/media/simplonbp-bold-webfont.b618513b.ttf";